<template>
    <div id="main" class="content">
        <div class="container">
            <section class="post_content">
                <header class="post_header">
                    <h1 class="post_title">友链</h1>
                </header>
                <div class="links">
                    <h3 class="catalog-title">Life Blog</h3>
                    <div class="catalog-description"></div>
                    <!--<div class="catalog-share">4 items in collection</div>-->
                    <div class="userItems">
                        <div class="userItem" onclick="window.open('http://tangzhe.name/')">
                            <div class="userItem--inner">
                                <div class="userItem-content"><img alt='' src='../../static/images/tangzhe.jpg' class='avatar avatar-64 photo' height='64' width='64' />
                                    <div class="userItem-name">
                                        <a class="link link--primary" href="javascript:void(0)" target="_blank">唐长老</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'flink'
    }
</script>

<style scoped>
    body .custom-background {
        background: #fff
    }
    .container {
        padding: 10px 0px;
    }
    .userItem {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/flink.vue